/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { parse } from 'uri-template';

/**
 * @import { Template } from 'uri-template/dist/ast'
 * @import { IVariablesNamespaceRegistry, VariablesValue } from '../variables'
 */

const sep = '.';

/**
 * Rozbalí URI template s danými daty a vrátí výslednou URI.
 * [RFC 6570](https://tools.ietf.org/html/rfc6570)
 * @param {string} template
 * @param {IVariablesNamespaceRegistry} registry
 * @returns {string}
 */
export function expand(template, registry) {
  try {
    const uri = parse(template);
    const templateData = getTemplateData(uri.ast, registry);
    return uri.expand(templateData);
  } catch (error) {
    throw new Error(`Failed to expand URI template: ${template}`);
  }
}

/**
 * @param {string} varName So separátorom '.'
 * @returns {[string, string, string]}
 */
function extractNsValue(varName) {
  const [ns, value] = varName.split(/\.(.*)/s);
  return [varName, ns, value];
}

/**
 * @param {Template} ast
 * @returns {string[]}
 */
function extractVarNames(ast) {
  return ast.parts
    .filter((part) => part.type === 'expression')
    .flatMap((part) => part.variables.map(({ name }) => name));
}

/**
 * @param {Template} ast
 * @param {IVariablesNamespaceRegistry} registry
 * @returns {Record<string, VariablesValue | undefined>}
 */
function getTemplateData(ast, registry) {
  return Object.fromEntries(
    nsValue(ast).map(([varName, ns, value]) => [
      varName,
      registry.get(ns)?.getValue(value)
    ])
  );
}

/**
 * @param {Template} ast
 * @returns {[string, string, string][]}
 */
function nsValue(ast) {
  return extractVarNames(ast)
    .filter((name) => name.includes(sep))
    .map(extractNsValue);
}
